import fileHandles from "upload/fileHandles";

export const ADD_ANOTHER_WORK = "submission/ADD_ANOTHER_WORK";
export const ACKNOWLEDGE_SUBMISSION_COMPLETE =
  "submission/ACKNOWLEDGE_SUBMISSION_COMPLETE";
export const CANCEL_SUBMISSION = "submission/CANCEL_SUBMISSION";
export const CANCEL_UPLOAD = "submission/CANCEL_UPLOAD";
export const INVALID_SUBMISSION = "submission/INVALID_SUBMISSION";
export const LOCAL_STORAGE_LOADED = "submission/LOCAL_STORAGE_LOADED";
export const LOCAL_STORAGE_SYNCED = "submission/LOCAL_STORAGE_SYNCED";
export const SEND_SUBMISSION = "submission/SEND_SUBMISSION";
export const SET_ACTIVE_STEP = "submission/SET_ACTIVE_STEP";
export const SET_WORK_TYPE_ID = "submission/SET_WORK_TYPE_ID";
export const SHOW_CANCEL_SUBMISSION_DIALOG =
  "submission/SHOW_CANCEL_SUBMISSION_DIALOG";
export const SHOW_INVALID_SUBMISSION_DIALOG =
  "submission/SHOW_INVALID_SUBMISSION_DIALOG";
export const SHOW_SUBMISSION_ERROR_DIALOG =
  "submission/SHOW_SUBMISSION_ERROR_DIALOG";
export const SHOW_VALIDATION_ERRORS_DIALOG =
  "submission/SHOW_VALIDATION_ERRORS_DIALOG";
export const SUBMISSION_ERROR = "submission/SUBMISSION_ERROR";
export const SUBMIT = "submission/SUBMIT";
export const UPLOAD_COMPLETE = "submission/UPLOAD_COMPLETE";
export const FILE_UPLOAD_COMPLETE = "submission/FILE_UPLOAD_COMPLETE";
export const UPLOAD_URL_CREATED = "submission/UPLOAD_URL_CREATED";

export const SET_SUBMISSION_FILES = "submission/SET_SUBMISSION_FILES";
export const SET_COVER_FILE = "submission/SET_COVER_FILE";
export const UPDATE_SUBMISSION_FILES = "submission/UPDATE_SUBMISSION_FILES";

export const UPLOAD_PROGRESS = "submission/UPLOAD_PROGRESS";
export const SHOW_EXISTING_SUBMISSIONS_DIALOG =
  "submission/SHOW_EXISTING_SUBMISSIONS_DIALOG";
export const SET_EXISTING_SUBMISSIONS_CHECKING =
  "submission/SET_EXISTING_SUBMISSIONS_CHECKING";

export const addAnotherWork = () => {
  fileHandles.cover = void 0;
  fileHandles.work = void 0;

  return {
    type: ADD_ANOTHER_WORK,
  };
};

export const invalidSubmission = firstInvalidStep => ({
  type: INVALID_SUBMISSION,
  firstInvalidStep,
});

export const localStorageLoaded = data => ({
  type: LOCAL_STORAGE_LOADED,
  data,
});

export const cancelSubmission = () => {
  window.scrollTo(0, 0);
  return { type: CANCEL_SUBMISSION };
};

export const localStorageSynced = () => ({ type: LOCAL_STORAGE_SYNCED });
export const sendSubmission = () => ({ type: SEND_SUBMISSION });
export const submissionError = () => ({ type: SUBMISSION_ERROR });
export const uploadComplete = () => ({ type: UPLOAD_COMPLETE });
export const uploadProgress = (step, percent) => ({
  type: UPLOAD_PROGRESS,
  step,
  percent,
});
export const fileUploadComplete = () => ({ type: FILE_UPLOAD_COMPLETE });
export const uploadUrlCreated = ({ uploadUrl, fileResource }) => ({
  type: UPLOAD_URL_CREATED,
  uploadUrl,
  fileResource,
});

export const setActiveStep = step => {
  window.scrollTo(0, 0);
  return { type: SET_ACTIVE_STEP, step };
};

export const showValidationErrorsDialog = show => {
  window.scrollTo(0, 0);
  return { type: SHOW_VALIDATION_ERRORS_DIALOG, show };
};

export const setWorkTypeId = workTypeId => {
  fileHandles.works = void 0;

  return {
    type: SET_WORK_TYPE_ID,
    workTypeId,
  };
};

export const setExistingSubmissionsChecking = checking => ({
  type: SET_EXISTING_SUBMISSIONS_CHECKING,
  checking,
});

export const showExistingSubmissionsDialog = (show, email) => ({
  type: SHOW_EXISTING_SUBMISSIONS_DIALOG,
  show,
  email,
});

export const changeSubmissionFiles = submissionFiles => {
  return {
    type: SET_SUBMISSION_FILES,
    fileResources: submissionFiles,
  };
};
